import { render, staticRenderFns } from "./StepUpdateAddress.vue?vue&type=template&id=1a805616&scoped=true&"
import script from "./StepUpdateAddress.vue?vue&type=script&lang=js&"
export * from "./StepUpdateAddress.vue?vue&type=script&lang=js&"
import style0 from "./StepUpdateAddress.vue?vue&type=style&index=0&id=1a805616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a805616",
  null
  
)

export default component.exports